import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ScrollReveal from "./ScrollReveal";

export default function FooterSection() {
  return (
    <>
      {/* Final CTA */}
      <section className="relative px-6 py-24 sm:py-32 bg-[hsl(var(--foreground)/0.02)]">
        {/* Radial glow behind CTA */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.08)_0%,transparent_60%)]" />

        <ScrollReveal>
          <div className="relative mx-auto max-w-2xl text-center">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-primary">
              The Grid Is Forming
            </p>
            <h2 className="mb-8 text-3xl font-black tracking-tight sm:text-4xl">Are you in?</h2>
            <Button
              size="lg"
              className="text-base font-bold px-8 transition-all duration-200 hover:scale-105 active:scale-95 hover:shadow-lg hover:shadow-primary/25 animate-pulse [animation-duration:3s]"
              asChild
            >
              <Link to="/sign-up">Join the Grid (It's Free)</Link>
            </Button>
          </div>
        </ScrollReveal>
      </section>

      {/* Footer */}
      <footer className="relative px-6 py-10">
        <div className="mx-auto max-w-4xl text-center">
          <p className="mb-4 text-xs text-muted-foreground leading-relaxed">
            This website is unofficial and is not associated in any way with the Formula&nbsp;1 companies. F1, FORMULA ONE, FORMULA&nbsp;1, FIA FORMULA ONE WORLD CHAMPIONSHIP, GRAND PRIX and related marks are trade marks of Formula One Licensing B.V. All team names and driver names are trade marks of their respective owners.
          </p>
          <div className="flex justify-center gap-6 text-sm">
            <Link to="/terms" className="text-muted-foreground/50 transition-colors hover:text-foreground">Terms</Link>
            <Link to="/privacy" className="text-muted-foreground/50 transition-colors hover:text-foreground">Privacy</Link>
            <Link to="/disclaimer" className="text-muted-foreground/50 transition-colors hover:text-foreground">Disclaimer</Link>
          </div>
        </div>
      </footer>
    </>
  );
}
